import { useTranslation } from 'react-i18next';

export interface SelectOption {
  value: number;
  option: string;
  checked?: boolean;
}

export interface SelectOptionString {
  value: string;
  option: string;
  checked?: boolean;
}

export interface SelectOptions {
  name: string;
  options: Array<{
    value: number;
    option: string;
    checked?: boolean;
  }>;
}

export const getValueFromSelectOption = (options: SelectOption[]): number[] => {
  const nums: number[] = [];
  const result = options.filter((option) => option.checked === true);

  result.forEach((option) => {
    nums.push(option.value);
  });
  return nums;
};

export const getValueFromSelectOptions = (
  options: SelectOptions[]
): number[] => {
  const checkedValues: number[] = [];

  options.forEach((option) => {
    option.options.forEach((item) => {
      if (item.checked) {
        checkedValues.push(item.value);
      }
    });
  });

  return checkedValues;
};

export const useIndustry = (): SelectOption[] => {
  const { t } = useTranslation();

  const industryList = [
    { option: t('industry.option1'), value: 1 },
    { option: t('industry.option2'), value: 2 },
    { option: t('industry.option3'), value: 3 },
    { option: t('industry.option4'), value: 4 },
    { option: t('industry.option5'), value: 5 },
    { option: t('industry.option6'), value: 6 },
    { option: t('industry.option7'), value: 7 },
    { option: t('industry.option8'), value: 8 },
    { option: t('industry.option9'), value: 9 },
    { option: t('industry.option10'), value: 10 },
    { option: t('industry.option11'), value: 11 },
    { option: t('industry.option12'), value: 12 },
    { option: t('industry.option13'), value: 13 },
    { option: t('industry.option14'), value: 14 },
    { option: t('industry.option15'), value: 15 },
    { option: t('industry.option16'), value: 16 },
    { option: t('industry.option17'), value: 17 },
    { option: t('industry.option18'), value: 18 },
    { option: t('industry.option19'), value: 19 },
    { option: t('industry.option20'), value: 20 },
    { option: t('industry.option21'), value: 21 },
    { option: t('industry.option22'), value: 22 },
    { option: t('industry.option23'), value: 23 },
    { option: t('industry.option99'), value: 99 }
  ];

  return industryList;
};

export const agentIndustry = (): SelectOption[] => {
  const { t } = useTranslation();

  const industryList = [
    { option: t('industry.option29'), value: 31 },
    { option: t('industry.option30'), value: 32 },
    { option: t('industry.option31'), value: 33 },
    { option: t('industry.option32'), value: 34 },
    { option: t('industry.option33'), value: 35 },
    { option: t('industry.option34'), value: 36 },
    { option: t('industry.option99'), value: 99 }
  ];

  return industryList;
};

export const publisherIndustry = (): SelectOption[] => {
  const { t } = useTranslation();

  const industryList = [
    { option: t('industry.option51'), value: 51 },
    { option: t('industry.option52'), value: 52 },
    { option: t('industry.option53'), value: 53 },
    { option: t('industry.option54'), value: 54 },
    { option: t('industry.option55'), value: 55 },
    { option: t('industry.option99'), value: 99 }
  ];

  return industryList;
};

export const prefecture = (): SelectOption[] => {
  const { t } = useTranslation();
  const prefectureList = [
    { option: t('prefecture.option1'), value: 1 },
    { option: t('prefecture.option2'), value: 2 },
    { option: t('prefecture.option3'), value: 3 },
    { option: t('prefecture.option4'), value: 4 },
    { option: t('prefecture.option5'), value: 5 },
    { option: t('prefecture.option6'), value: 6 },
    { option: t('prefecture.option7'), value: 7 },
    { option: t('prefecture.option8'), value: 8 },
    { option: t('prefecture.option9'), value: 9 },
    { option: t('prefecture.option10'), value: 10 },
    { option: t('prefecture.option11'), value: 11 },
    { option: t('prefecture.option12'), value: 12 },
    { option: t('prefecture.option13'), value: 13 },
    { option: t('prefecture.option14'), value: 14 },
    { option: t('prefecture.option15'), value: 15 },
    { option: t('prefecture.option16'), value: 16 },
    { option: t('prefecture.option17'), value: 17 },
    { option: t('prefecture.option18'), value: 18 },
    { option: t('prefecture.option19'), value: 19 },
    { option: t('prefecture.option20'), value: 20 },
    { option: t('prefecture.option21'), value: 21 },
    { option: t('prefecture.option22'), value: 22 },
    { option: t('prefecture.option23'), value: 23 },
    { option: t('prefecture.option24'), value: 24 },
    { option: t('prefecture.option25'), value: 25 },
    { option: t('prefecture.option26'), value: 26 },
    { option: t('prefecture.option27'), value: 27 },
    { option: t('prefecture.option28'), value: 28 },
    { option: t('prefecture.option29'), value: 29 },
    { option: t('prefecture.option30'), value: 30 },
    { option: t('prefecture.option31'), value: 31 },
    { option: t('prefecture.option32'), value: 32 },
    { option: t('prefecture.option33'), value: 33 },
    { option: t('prefecture.option34'), value: 34 },
    { option: t('prefecture.option35'), value: 35 },
    { option: t('prefecture.option36'), value: 36 },
    { option: t('prefecture.option37'), value: 37 },
    { option: t('prefecture.option38'), value: 38 },
    { option: t('prefecture.option39'), value: 39 },
    { option: t('prefecture.option40'), value: 40 },
    { option: t('prefecture.option41'), value: 41 },
    { option: t('prefecture.option42'), value: 42 },
    { option: t('prefecture.option43'), value: 43 },
    { option: t('prefecture.option44'), value: 44 },
    { option: t('prefecture.option45'), value: 45 },
    { option: t('prefecture.option46'), value: 46 },
    { option: t('prefecture.option47'), value: 47 }
  ];

  return prefectureList;
};

export const purpose = (): SelectOption[] => {
  const { t } = useTranslation();

  const purposeList = [
    { option: t('purpose.option1'), value: 1 },
    { option: t('purpose.option2'), value: 2 },
    { option: t('purpose.option4'), value: 4 },
    { option: t('purpose.option3'), value: 3 },
    { option: t('purpose.option99'), value: 99 }
  ];

  return purposeList;
};

export const budget = (): SelectOption[] => {
  const { t } = useTranslation();

  const budgetList = [
    { option: t('budget.option1'), value: 1 },
    { option: t('budget.option2'), value: 2 },
    { option: t('budget.option3'), value: 3 },
    { option: t('budget.option4'), value: 4 },
    { option: t('budget.option5'), value: 5 },
    { option: t('budget.option6'), value: 6 },
    { option: t('budget.option7'), value: 7 }
  ];

  return budgetList;
};

export const industryType = (): SelectOption[] => {
  const { t } = useTranslation();

  const industryList = [
    { option: t('industry.option24'), value: 24 },
    { option: t('industry.option25'), value: 25 },
    { option: t('industry.option26'), value: 26 },
    { option: t('industry.option27'), value: 27 },
    { option: t('industry.option28'), value: 28 },
    { option: t('industry.option99'), value: 99 }
  ];

  return industryList;
};

export const sales = (): SelectOption[] => {
  const { t } = useTranslation();

  const salesList = [
    { option: t('sales.option1'), value: 1 },
    { option: t('sales.option10'), value: 10 },
    { option: t('sales.option20'), value: 20 },
    { option: t('sales.option30'), value: 30 },
    { option: t('sales.option40'), value: 40 },
    { option: t('sales.option50'), value: 50 },
    { option: t('sales.option60'), value: 60 },
    { option: t('sales.option70'), value: 70 },
    { option: t('sales.option80'), value: 80 },
    { option: t('sales.option90'), value: 90 }
  ];

  return salesList;
};

export const fiscalMonth = (): SelectOption[] => {
  const { t } = useTranslation();

  const fiscalMonthList = [
    { option: `1${t('form.month')}`, value: 1 },
    { option: `2${t('form.month')}`, value: 2 },
    { option: `3${t('form.month')}`, value: 3 },
    { option: `4${t('form.month')}`, value: 4 },
    { option: `5${t('form.month')}`, value: 5 },
    { option: `6${t('form.month')}`, value: 6 },
    { option: `7${t('form.month')}`, value: 7 },
    { option: `8${t('form.month')}`, value: 8 },
    { option: `9${t('form.month')}`, value: 9 },
    { option: `10${t('form.month')}`, value: 10 },
    { option: `11${t('form.month')}`, value: 11 },
    { option: `12${t('form.month')}`, value: 12 }
  ];

  return fiscalMonthList;
};

export const categoryList = (): SelectOption[] => {
  const { t } = useTranslation();

  const categories = [
    { checked: false, option: t('category.option1'), value: 1 },
    { checked: false, option: t('category.option2'), value: 2 },
    { checked: false, option: t('category.option3'), value: 3 },
    { checked: false, option: t('category.option4'), value: 4 },
    { checked: false, option: t('category.option5'), value: 5 },
    { checked: false, option: t('category.option24'), value: 24 },
    { checked: false, option: t('category.option25'), value: 25 },
    { checked: false, option: t('category.option8'), value: 8 },
    { checked: false, option: t('category.option9'), value: 9 },
    { checked: false, option: t('category.option10'), value: 10 },
    { checked: false, option: t('category.option11'), value: 11 },
    { checked: false, option: t('category.option12'), value: 12 },
    { checked: false, option: t('category.option13'), value: 13 },
    { checked: false, option: t('category.option14'), value: 14 },
    { checked: false, option: t('category.option15'), value: 15 },
    { checked: false, option: t('category.option16'), value: 16 },
    { checked: false, option: t('category.option17'), value: 17 },
    { checked: false, option: t('category.option18'), value: 18 },
    { checked: false, option: t('category.option19'), value: 19 },
    { checked: false, option: t('category.option20'), value: 20 },
    { checked: false, option: t('category.option21'), value: 21 },
    { checked: false, option: t('category.option22'), value: 22 },
    { checked: false, option: t('category.option23'), value: 23 },
    { checked: false, option: t('category.option99'), value: 99 }
  ];

  return categories;
};

export const categoryListForReference = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { checked: false, option: t('category.option1'), value: 1 },
    { checked: false, option: t('category.option2'), value: 2 },
    { checked: false, option: t('category.option3'), value: 3 },
    { checked: false, option: t('category.option4'), value: 4 },
    { checked: false, option: t('category.option5'), value: 5 },
    { checked: false, option: t('category.option6'), value: 6 },
    { checked: false, option: t('category.option7'), value: 7 },
    { checked: false, option: t('category.option8'), value: 8 },
    { checked: false, option: t('category.option9'), value: 9 },
    { checked: false, option: t('category.option10'), value: 10 },
    { checked: false, option: t('category.option11'), value: 11 },
    { checked: false, option: t('category.option12'), value: 12 },
    { checked: false, option: t('category.option13'), value: 13 },
    { checked: false, option: t('category.option14'), value: 14 },
    { checked: false, option: t('category.option15'), value: 15 },
    { checked: false, option: t('category.option16'), value: 16 },
    { checked: false, option: t('category.option17'), value: 17 },
    { checked: false, option: t('category.option18'), value: 18 },
    { checked: false, option: t('category.option19'), value: 19 },
    { checked: false, option: t('category.option20'), value: 20 },
    { checked: false, option: t('category.option21'), value: 21 },
    { checked: false, option: t('category.option22'), value: 22 },
    { checked: false, option: t('category.option23'), value: 23 },
    { checked: false, option: t('category.option24'), value: 24 },
    { checked: false, option: t('category.option25'), value: 25 },
    { checked: false, option: t('category.option99'), value: 99 }
  ];
};

export const mediaIndustriesList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { checked: false, option: t('mediaIndustry.option1'), value: 1 },
    { checked: false, option: t('mediaIndustry.option2'), value: 2 },
    { checked: false, option: t('mediaIndustry.option3'), value: 3 },
    { checked: false, option: t('mediaIndustry.option4'), value: 4 },
    { checked: false, option: t('mediaIndustry.option5'), value: 5 },
    { checked: false, option: t('mediaIndustry.option6'), value: 6 },
    { checked: false, option: t('mediaIndustry.option7'), value: 7 },
    { checked: false, option: t('mediaIndustry.option8'), value: 8 },
    { checked: false, option: t('mediaIndustry.option9'), value: 9 },
    { checked: false, option: t('mediaIndustry.option10'), value: 10 },
    { checked: false, option: t('mediaIndustry.option11'), value: 11 },
    { checked: false, option: t('mediaIndustry.option12'), value: 12 },
    { checked: false, option: t('mediaIndustry.option13'), value: 13 },
    { checked: false, option: t('mediaIndustry.option14'), value: 14 },
    { checked: false, option: t('mediaIndustry.option15'), value: 15 },
    { checked: false, option: t('mediaIndustry.option16'), value: 16 },
    { checked: false, option: t('mediaIndustry.option17'), value: 17 },
    { checked: false, option: t('mediaIndustry.option18'), value: 18 },
    { checked: false, option: t('mediaIndustry.option19'), value: 19 },
    { checked: false, option: t('mediaIndustry.option20'), value: 20 },
    { checked: false, option: t('mediaIndustry.option21'), value: 21 },
    { checked: false, option: t('mediaIndustry.option22'), value: 22 },
    { checked: false, option: t('mediaIndustry.option23'), value: 23 },
    { checked: false, option: t('mediaIndustry.option99'), value: 99 }
  ];
};

export const mediaTargetList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { checked: false, option: t('media.targetOption.1'), value: 1 },
    { checked: false, option: t('media.targetOption.2'), value: 2 },
    { checked: false, option: t('media.targetOption.3'), value: 3 },
    { checked: false, option: t('media.targetOption.4'), value: 4 },
    { checked: false, option: t('media.targetOption.5'), value: 5 },
    { checked: false, option: t('media.targetOption.6'), value: 6 },
    { checked: false, option: t('media.targetOption.7'), value: 7 },
    { checked: false, option: t('media.targetOption.8'), value: 8 },
    { checked: false, option: t('media.targetOption.9'), value: 9 },
    { checked: false, option: t('media.targetOption.10'), value: 10 },
    { checked: false, option: t('media.targetOption.11'), value: 11 },
    { checked: false, option: t('media.targetOption.12'), value: 12 },
    { checked: false, option: t('media.targetOption.13'), value: 13 },
    { checked: false, option: t('media.targetOption.14'), value: 14 }
  ];
};

export const mediaTypeList = (): SelectOptions[] => {
  const { t } = useTranslation();
  return [
    {
      name: t('media.mediaTypeOption.tv'),
      options: [
        {
          checked: false,
          option: t('media.mediaTypeOption.41'),
          value: 41
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.42'),
          value: 42
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.43'),
          value: 43
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.44'),
          value: 44
        }
      ]
    },
    {
      name: t('media.mediaTypeOption.radio'),
      options: [
        {
          checked: false,
          option: t('media.mediaTypeOption.51'),
          value: 51
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.52'),
          value: 52
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.53'),
          value: 53
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.54'),
          value: 54
        }
      ]
    },
    {
      name: t('media.mediaTypeOption.web'),
      options: [
        {
          checked: false,
          option: t('media.mediaTypeOption.61'),
          value: 61
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.62'),
          value: 62
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.66'),
          value: 66
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.67'),
          value: 67
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.63'),
          value: 63
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.64'),
          value: 64
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.65'),
          value: 65
        }
      ]
    },
    {
      name: t('media.mediaTypeOption.paper'),
      options: [
        {
          checked: false,
          option: t('media.mediaTypeOption.71'),
          value: 71
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.72'),
          value: 72
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.73'),
          value: 73
        }
      ]
    },
    {
      name: t('media.mediaTypeOption.magazine'),
      options: [
        {
          checked: false,
          option: t('media.mediaTypeOption.21'),
          value: 21
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.22'),
          value: 22
        },
        {
          checked: false,
          option: t('media.mediaTypeOption.23'),
          value: 23
        }
      ]
    },
    {
      name: t('media.mediaTypeOption.other'),
      options: [
        {
          checked: false,
          option: t('media.mediaTypeOption.31'),
          value: 31
        }
      ]
    }
  ];
};

// 与件検索のメディアタイプ
export const mediaTypes = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('mediaType.label5'), value: 5 },
    { option: t('mediaType.label6'), value: 6 },
    { option: t('mediaType.label7'), value: 7 },
    { option: t('mediaType.label8'), value: 8 },
    { option: t('mediaType.label9'), value: 9 },
    { option: t('mediaType.label10'), value: 10 },
    { option: t('mediaType.label99'), value: 99 }
  ];
};

export const funnelList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { checked: false, option: t('media.funnelOption.1'), value: 1 },
    { checked: false, option: t('media.funnelOption.2'), value: 2 },
    { checked: false, option: t('media.funnelOption.3'), value: 3 },
    { checked: false, option: t('media.funnelOption.4'), value: 4 },
    { checked: false, option: t('media.funnelOption.5'), value: 5 },
    { checked: false, option: t('media.funnelOption.6'), value: 6 }
  ];
};

export const funnelListForReference = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { checked: false, option: t('media.funnelOption.1'), value: 1 },
    { checked: false, option: t('media.funnelOption.2'), value: 2 },
    { checked: false, option: t('media.funnelOption.3'), value: 3 },
    { checked: false, option: t('media.funnelOption.4'), value: 4 },
    { checked: false, option: t('media.funnelOption.5'), value: 5 },
    { checked: false, option: t('media.funnelOption.show6'), value: 6 }
  ];
};

export const targetTypeList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { checked: false, option: t('media.targetTypeOption.1'), value: 1 },
    { checked: false, option: t('media.targetTypeOption.2'), value: 2 },
    { checked: false, option: t('media.targetTypeOption.3'), value: 3 }
  ];
};

export const percentList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.percentOption.0'), value: 0 },
    { option: t('media.percentOption.5'), value: 5 },
    { option: t('media.percentOption.10'), value: 10 },
    { option: t('media.percentOption.15'), value: 15 },
    { option: t('media.percentOption.20'), value: 20 },
    { option: t('media.percentOption.25'), value: 25 },
    { option: t('media.percentOption.30'), value: 30 },
    { option: t('media.percentOption.35'), value: 35 },
    { option: t('media.percentOption.40'), value: 40 },
    { option: t('media.percentOption.45'), value: 45 },
    { option: t('media.percentOption.50'), value: 50 },
    { option: t('media.percentOption.55'), value: 55 },
    { option: t('media.percentOption.60'), value: 60 },
    { option: t('media.percentOption.65'), value: 65 },
    { option: t('media.percentOption.70'), value: 70 },
    { option: t('media.percentOption.75'), value: 75 },
    { option: t('media.percentOption.80'), value: 80 },
    { option: t('media.percentOption.85'), value: 85 },
    { option: t('media.percentOption.90'), value: 90 },
    { option: t('media.percentOption.95'), value: 95 },
    { option: t('media.percentOption.100'), value: 100 }
  ];
};

export const generationList = (): SelectOptionString[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.geneOption.f10'), value: 'f10' },
    { option: t('media.geneOption.f20'), value: 'f20' },
    { option: t('media.geneOption.f30'), value: 'f30' },
    { option: t('media.geneOption.f40'), value: 'f40' },
    { option: t('media.geneOption.f50'), value: 'f50' },
    { option: t('media.geneOption.f60'), value: 'f60' },
    { option: t('media.geneOption.f70'), value: 'f70' },
    { option: t('media.geneOption.m10'), value: 'm10' },
    { option: t('media.geneOption.m20'), value: 'm20' },
    { option: t('media.geneOption.m30'), value: 'm30' },
    { option: t('media.geneOption.m40'), value: 'm40' },
    { option: t('media.geneOption.m50'), value: 'm50' },
    { option: t('media.geneOption.m60'), value: 'm60' },
    { option: t('media.geneOption.m70'), value: 'm70' }
  ];
};

export const accessList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.accessOption.1'), value: 1 },
    { option: t('media.accessOption.2'), value: 2 },
    { option: t('media.accessOption.3'), value: 3 },
    { option: t('media.accessOption.4'), value: 4 },
    { option: t('media.accessOption.5'), value: 5 },
    { option: t('media.accessOption.6'), value: 6 },
    { option: t('media.accessOption.7'), value: 7 },
    { option: t('media.accessOption.8'), value: 8 }
  ];
};

export const budgetList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.budgetOption.100000'), value: 1 },
    { option: t('media.budgetOption.500000'), value: 2 },
    { option: t('media.budgetOption.1000000'), value: 3 },
    { option: t('media.budgetOption.1500000'), value: 4 },
    { option: t('media.budgetOption.above'), value: 5 }
  ];
};

export const adTypeList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.adTypeOption.1'), value: 1 },
    { option: t('media.adTypeOption.2'), value: 2 },
    { option: t('media.adTypeOption.3'), value: 3 },
    { option: t('media.adTypeOption.4'), value: 4 },
    { option: t('media.adTypeOption.5'), value: 5 },
    { option: t('media.adTypeOption.6'), value: 6 },
    { option: t('media.adTypeOption.7'), value: 7 },
    { option: t('media.adTypeOption.8'), value: 8 },
    { option: t('media.adTypeOption.99'), value: 99 }
  ];
};

export const mediaBudgetList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.budgetOption.1'), value: 1 },
    { option: t('media.budgetOption.2'), value: 2 },
    { option: t('media.budgetOption.3'), value: 3 },
    { option: t('media.budgetOption.4'), value: 4 },
    { option: t('media.budgetOption.5'), value: 5 }
  ];
};

export const guaranteeFlgList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.guaranteeFlgOption.1'), value: 1 },
    { option: t('media.guaranteeFlgOption.2'), value: 2 }
  ];
};

export const mainKpiList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.mainKpiOption.1'), value: 1 },
    { option: t('media.mainKpiOption.2'), value: 2 },
    { option: t('media.mainKpiOption.3'), value: 3 },
    { option: t('media.mainKpiOption.4'), value: 4 },
    { option: t('media.mainKpiOption.5'), value: 5 },
    { option: t('media.mainKpiOption.6'), value: 6 },
    { option: t('media.mainKpiOption.7'), value: 7 },
    { option: t('media.mainKpiOption.8'), value: 8 },
    { option: t('media.mainKpiOption.9'), value: 9 },
    { option: t('media.mainKpiOption.99'), value: 99 }
  ];
};

export const paymentList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.paymentOption.1'), value: 1 },
    { option: t('media.paymentOption.2'), value: 2 },
    { option: t('media.paymentOption.3'), value: 3 },
    { option: t('media.paymentOption.4'), value: 4 },
    { option: t('media.paymentOption.5'), value: 5 },
    { option: t('media.paymentOption.6'), value: 6 },
    { option: t('media.paymentOption.7'), value: 7 },
    { option: t('media.paymentOption.8'), value: 8 },
    { option: t('media.paymentOption.99'), value: 99 }
  ];
};

export const mediaMaterialUpdateList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('media.mediaMaterialUpdateCycleOption.1'), value: 1 },
    { option: t('media.mediaMaterialUpdateCycleOption.2'), value: 2 },
    { option: t('media.mediaMaterialUpdateCycleOption.3'), value: 3 },
    { option: t('media.mediaMaterialUpdateCycleOption.99'), value: 99 }
  ];
};
export const targetList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { checked: false, option: t('media.targetOption.1'), value: 1 },
    { checked: false, option: t('media.targetOption.2'), value: 2 },
    { checked: false, option: t('media.targetOption.3'), value: 3 },
    { checked: false, option: t('media.targetOption.4'), value: 4 },
    { checked: false, option: t('media.targetOption.5'), value: 5 },
    { checked: false, option: t('media.targetOption.6'), value: 6 },
    { checked: false, option: t('media.targetOption.7'), value: 7 },
    { checked: false, option: t('media.targetOption.8'), value: 8 },
    { checked: false, option: t('media.targetOption.9'), value: 9 },
    { checked: false, option: t('media.targetOption.10'), value: 10 },
    { checked: false, option: t('media.targetOption.11'), value: 11 },
    { checked: false, option: t('media.targetOption.12'), value: 12 },
    { checked: false, option: t('media.targetOption.13'), value: 13 }
  ];
};

export const genreList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('issue.genreList.option1'), value: 1 },
    { option: t('issue.genreList.option2'), value: 2 },
    { option: t('issue.genreList.option3'), value: 3 },
    { option: t('issue.genreList.option4'), value: 4 },
    { option: t('issue.genreList.option5'), value: 5 },
    { option: t('issue.genreList.option6'), value: 6 },
    { option: t('issue.genreList.option7'), value: 7 },
    { option: t('issue.genreList.option8'), value: 8 },
    { option: t('issue.genreList.option9'), value: 9 },
    { option: t('issue.genreList.option10'), value: 10 },
    { option: t('issue.genreList.option11'), value: 11 },
    { option: t('issue.genreList.option12'), value: 12 },
    { option: t('issue.genreList.option13'), value: 13 },
    { option: t('issue.genreList.option14'), value: 14 },
    { option: t('issue.genreList.option15'), value: 15 },
    { option: t('issue.genreList.option16'), value: 16 },
    { option: t('issue.genreList.option17'), value: 17 },
    { option: t('issue.genreList.option18'), value: 18 },
    { option: t('issue.genreList.option19'), value: 19 },
    { option: t('issue.genreList.option20'), value: 20 },
    { option: t('issue.genreList.option21'), value: 21 },
    { option: t('issue.genreList.option22'), value: 22 },
    { option: t('issue.genreList.option23'), value: 23 },
    { option: t('issue.genreList.option99'), value: 99 }
  ];
};

export const menuList = (): SelectOption[] => {
  const { t } = useTranslation();
  return [
    { option: t('menu.label6'), value: 6 },
    { option: t('menu.label7'), value: 7 },
    { option: t('menu.label8'), value: 8 },
    { option: t('menu.label9'), value: 9 },
    { option: t('menu.label10'), value: 10 },
    { option: t('menu.label11'), value: 11 },
    { option: t('menu.label12'), value: 12 },
    { option: t('menu.label13'), value: 13 },
    { option: t('menu.label99'), value: 99 }
  ];
};
